<app-step-progress [steps]="steps"></app-step-progress>
<app-sitting-selection></app-sitting-selection>
